import React from "react";
import "./styles.css";

const products = [
  "Industrial Solutions",
  "Premium Manufacturing Products",
  "Automation Systems",
  "Custom Enterprise Solutions",
];
const services = [
  "Consultation & Planning",
  "Installation Support",
  "Quality Management",
  "Maintenance Services",
];

function App() {
  return (
    <div>
      <header>
        <img src="/images/logo.svg" />
        <nav>
          <a>Home</a>
          <a>About</a>
          <a>Products</a>
          <a>Services</a>
          <a>Contact</a>
        </nav>
        <button>☰</button>
      </header>

      <section className="hero">
        <div>
          <span>INNOVATION • QUALITY • TRUST</span>
          <h1>Powering Businesses With Next Generation Solutions</h1>
          <p>
            SMMHILLS TECHNOLOGY SERVICES PRIVATE LIMITED delivers reliable
            industrial and enterprise solutions designed for performance and
            growth.
          </p>
          <button>Explore Solutions →</button>
        </div>
        <div className="visual">
          XTREME
          <br />
          SOLUTIONS
        </div>
      </section>

      <section className="stats">
        <div>
          <b>15+</b>
          <p>Years Experience</p>
        </div>
        <div>
          <b>500+</b>
          <p>Projects Delivered</p>
        </div>
        <div>
          <b>100%</b>
          <p>Quality Focus</p>
        </div>
      </section>

      <section>
        <h2>About SMMHILLS TECHNOLOGY SERVICES PRIVATE LIMITED</h2>
        <p>
          We combine technology, expertise and innovation to provide
          high-performance solutions for modern businesses. Our commitment is to
          deliver quality products with exceptional customer support.
        </p>
      </section>

      <section>
        <h2>Our Products</h2>
        <div className="grid">
          {products.map((x) => (
            <article>
              <h3>{x}</h3>
              <p>
                Advanced solutions engineered for reliability, efficiency and
                long-term value.
              </p>
            </article>
          ))}
        </div>
      </section>

      <section>
        <h2>Our Services</h2>
        <div className="grid">
          {services.map((x) => (
            <article>
              <h3>{x}</h3>
              <p>
                Professional service support from planning to successful
                execution.
              </p>
            </article>
          ))}
        </div>
      </section>

      <section className="dark">
        <h2>Why Choose Us</h2>
        <div className="grid">
          <article style={{ color: "#000" }}>Premium Quality</article>
          <article style={{ color: "#000" }}>Expert Team</article>
          <article style={{ color: "#000" }}>Customer First Approach</article>
        </div>
      </section>

      <section>
        <h2>Client Reviews</h2>
        <div className="reviews">
          <p>"Excellent quality and timely delivery."</p>
          <p>"Professional team with outstanding support."</p>
          <p>"A trusted partner for our business."</p>
        </div>
      </section>

      <section>
        <h2>Contact Us</h2>
        <p>Name: Pramodh Kumar H R</p>
        <p>Legal Name: SMMHILLS TECHNOLOGY SERVICES PRIVATE LIMITED</p>
        <p>Email: admin@jayashreextreme.online</p>
        <p>Phone: +91 84315 48370</p>
        <p>
          Address: 1st Floor, 107&108, Main Road, Opp Inchara Hotel, K R Layout,
          J.P Nagar 6th Phase, Bengaluru, Bengaluru Urban, Karnataka, 560078
        </p>
        <form>
          <input placeholder="Name" />
          <input placeholder="Email" />
          <input placeholder="Phone" />
          <textarea placeholder="Message" />
          <button>Send Enquiry</button>
        </form>
      </section>

      <footer>© 2026 SMMHILLS TECHNOLOGY SERVICES PRIVATE LIMITED</footer>
    </div>
  );
}
export default App;
